/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Createfolder3Inputs */

const en_coinvestments_dataroom_createfolder3 = /** @type {(inputs: Coinvestments_Dataroom_Createfolder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create folder`)
};

/**
* | output |
* | --- |
* | "Create folder" |
*
* @param {Coinvestments_Dataroom_Createfolder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_createfolder3 = /** @type {((inputs?: Coinvestments_Dataroom_Createfolder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Createfolder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_createfolder3(inputs)
});
export { coinvestments_dataroom_createfolder3 as "coInvestments_dataRoom_createFolder" }